import React from "react";

import { BsBoxSeam } from "react-icons/bs";

import BadgeType from "../../../../../components/Generic/BadgeType";
import { Sales } from "../../../../../models/sales";
import { handleGetConvertValue } from "../../../../../util/converts";
import { getMeasurement } from "../../../../../util/getMeasurement";
import { Header, HeaderTitle, HeaderBadges, VolumeBadge } from "./styles";

interface TabHeaderProps {
  title: string;
  job?: Sales;
}
export const TabHeader = (props: TabHeaderProps) => {
  const { title, job } = props;

  const { code: measurementCode, decimalPlaces } = getMeasurement();
  const measurementToShow = measurementCode === "ft³" ? "FT3" : "M3";

  const volumeInventory = () => {
    let totalItems: number = 0;

    job?.inventory?.forEach((roomJob) => {
      totalItems += roomJob.itemsJob.reduce(
        (total: number, item) =>
          total + Number(item.itemJob.volume) * Number(item.itemJob.quantity),
        0
      );
    });

    return totalItems;
  };

  return (
    <Header>
      <HeaderTitle>{title}</HeaderTitle>
      <HeaderBadges>
        <BadgeType value={job?.jobTypeName} />
        <VolumeBadge>
          <BsBoxSeam />
          <span>
            {handleGetConvertValue(volumeInventory(), measurementCode, decimalPlaces)}{" "}
            {measurementToShow}
          </span>
        </VolumeBadge>
      </HeaderBadges>
    </Header>
  );
};
